var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-insertion"},[_c('InsertPanel',{attrs:{"visible":_vm.insertPanelVisible,"features":_vm.features},on:{"update:visible":function($event){_vm.insertPanelVisible=$event},"insert":_vm.handleInsert,"close":_vm.handleInsertPanelClose}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-06ae3c18","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/ContentInsertion.vue
// module id = null
// module chunks = 